import { Observable } from 'rxjs';
import { TSearchResponseDTO } from '../../modules/points/point-search/point-search.consts';

export type TInfiniteScrollData = {
  [api: string]: TInfiniteScrollingRequestData;
};

export type TInfiniteScrollingRequestData = {
  loading: boolean;
  data: any[];
  nextCursor: TCursor;
  hasNext: boolean;
  totalCount: number;
  pageSize: number;
};

export type TCursor = {
  pointId: string;
  updatedAt: number;
}; // add other cursor types if needed

export type TInfiniteScrollQuery = TSearchResponseDTO; // add other query types if needed

export enum EInfiniteScrollApiKey {
  OVERVIEW_POINTS = 'overview_points',
  TIMELINE_POINTS = 'timeline_points',
  REMINDERS = 'reminders',
}

export type TInfiniteScrollRequest = (query: TInfiniteScrollQuery) => Observable<any>;
